//import { useState } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import useAuth from './auth/UseAuth';
//import './SideNav.css';

export function SideNav() {
    const { user } = useAuth();
    //const [collapsed, setCollapsed] = useState(false);

    //const handleToggleNavbar = (collapsed) => {
    //    setCollapsed(!collapsed);
    //}
    const collapsed = false;

    return (
        <div className={"col-md-3 col-lg-2 d-md-block bg-primary sidebar " + (collapsed ? 'collapse' : '') }>
            <div className="d-flex flex-column flex-shrink-0 p-3 text-white">
                <img src="/logo.png" width="200" alt="" />
                <hr />
                <ul className="nav nav-pills flex-column mb-auto">
                    <NavItem >
                        <div className="p-3">Current User: {`${user?.firstName} ${user?.lastName}`}</div>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} className="text-white" to="/" reloadDocument><span className="bi bi-window"></span> Create</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} className="text-white" to="/Search"><span className="bi bi-search"></span> Search for Worksheets</NavLink>
                    </NavItem>
                    {user?.roles && user.roles.includes('Admin') &&
                        <NavItem>
                            <NavLink tag={Link} className="text-white" to="/Admin/InsuranceMappings"><span className="bi bi-config"></span> Admin: Edit Insurance Mappings</NavLink>
                        </NavItem>
                    }
                    {user?.roles && user.roles.includes('Admin') &&
                        <NavItem>
                            <NavLink tag={Link} className="text-white" to="/Admin/Troubleshooting"><span className="bi bi-config"></span> Admin: Troubleshooting</NavLink>
                        </NavItem>
                    }
                </ul>
            </div>
        </div>
    );
};
